goog.provide('el8.data.reportTypes');

goog.require('el8.model.base');


el8.data.reportTypes = (function() {

    var _class = function(spec) { this.populate(spec); };
    // this model isn't actually an el8_Entity... the id corresponds to an enum,
    // so we won't be able to use idToModelClass on it
    _class.inheritsFrom(el8_Entity);
    _class.makeSortable();

    _class.addStringProperty('nickname'); // short name like "Lab"
    _class.addStringProperty('userLabel'); // long name like "Laboratory"
    _class.addStringProperty('reportTypeLabel'); // the equivalent to the key that comes down as reportType on Reports but uppercase

    // This is a lowercase version of reportTypeLabel, which comes down as report_type
    // in the Report JSON. Because of its appearance there, there are a host of JS
    // pieces that use it as a key... it'd be nice to move to document_sub_type instead
    _class.prototype.getClientReportTypeKey = function() {
        return this.getReportTypeLabel().toLowerCase();
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('reportTypes'); },
        urlFn: function(id) { return el8.service.urls.get('reportTypes', [id]); },
        urlSort: function() { return el8.service.urls.get('sortReportTypes'); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('reportTypes', [item.getId()]),
                success: function(data) {
                    item.populate(data);
                    if (successCb) { successCb(); }
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('reportTypes', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });
    that.makeSetSortable();

    // return the soymaps in groups of el8.util.consts.REPORT_TYPES_PER_ROW
    that.groupedSoyMaps = function() {
        var soyMaps = that.sortedAsSoyMaps();
        var groupedMaps = [];
        
        var groupSize = el8.util.consts.REPORT_TYPES_PER_ROW;
        for (var i=0; i < soyMaps.length; i += groupSize) {
            groupedMaps.push(soyMaps.slice(i, i + groupSize));
        }

        return groupedMaps;
    };

    return that;

})();